import http from "../../http-common";

class ScreenService {

    getContractor(data) {
        return http.post(`/swipeScreen/dashboard`, data);
    }

    getEmployee(data) {
        return http.post(`/swipeScreen/nextSwipe`, data);
    }

    getSwipeData(data) {
        return http.post(`/swipeScreen/swipeData`, data);
    }

    getFoodDetails(data) {
        return http.post(`/swipeScreen/getFoodDetails`, data);
    }

    updateDelivery(data) {
        return http.post(`/swipeScreen/updateDelivery`, data);
    }

}

export default new ScreenService();